/* Mezcla las tarjetas del catálogo de Ricoseller USA REPARTIDAS entre las de
   Argentina, sin separador ni aviso: sólo las distingue el cartelito. Hasta el
   2026-10-25 iban todas al final; se cambió porque el puente desde
   ricoseller.net ya traía 16 de los 44 pedidos mensuales de la tienda de USA
   estando enterradas abajo, y ese producto no consume capital. Los datos salen de catalogo-usa.json, que
   se regenera solo todos los días (ver ~/ricoseller-catalogo-usa).

   Se pinta del lado del navegador a propósito: así estos productos no entran
   al HTML y Google no enfrenta ricoseller.net con us.ricoseller.net por el
   mismo producto.

   OJO con el observador: pintar() toca la misma grilla que el MutationObserver
   vigila, así que hay que desconectarlo antes de tocar el DOM y reconectarlo
   después. Si no, cada repintado se dispara a sí mismo y queda un bucle
   infinito cada 80ms (medido: 38 repintados en 3 segundos).

   Lo que no se puede: los contadores al lado de cada filtro ("Nike (269)")
   los calcula Shopify en el servidor y no incluyen estos productos. */
(function () {
  var FUENTE = document.documentElement.getAttribute("data-catalogo-usa-json");
  if (!FUENTE) return;

  var datos = null;
  var observador = null;

  /* CUANTAS TARJETAS DE USA ENTRAN.

     Hasta el 2026-10-30 era un tope fijo de 48 y escondia 304 de los 352
     productos de USA. El numero no era un limite de rendimiento sino de
     proporcion: las tarjetas se insertan en la grilla YA CARGADA, asi que 48
     no eran 48 "por pagina" -- eran 48 en toda la navegacion, porque el
     scroll infinito hace crecer la grilla sin traer ninguna mas de USA.
     Subirlo a secas habria inundado la primera pantalla.

     Ahora la cantidad sigue a la grilla: una de USA cada dos de Argentina.
     La primera pantalla conserva la proporcion de siempre y, a medida que el
     cliente baja, va apareciendo el resto del catalogo de USA hasta agotarlo.

     MINIMO existe para las colecciones flacas: si Argentina tiene 4 productos
     igual se muestran 12 de USA, que es justo donde mas falta hace.
     TECHO es un seguro de rendimiento, no de diseno: con 352 tarjetas en el
     DOM el scroll en telefono se vuelve pesado. Con una cada dos, para que
     mordiera harian falta 400 productos nativos cargados. */
  var POR_CADA = 2;
  var MINIMO = 12;
  var TECHO = 200;

  function cuantasEntran(grid, disponibles) {
    var n = nativas(grid).length;
    var quiero = Math.max(MINIMO, Math.round(n / POR_CADA));
    return Math.min(disponibles, quiero, TECHO);
  }

  function pesos(n) {
    return "$" + Number(n).toLocaleString("es-AR");
  }

  function valores(params, clave) {
    var out = [];
    params.forEach(function (v, k) {
      if (k === clave) out.push(v);
    });
    return out;
  }

  /* Marca y atleta viajan en la URL como id de metaobjeto ARGENTINO, así que
     hay que traducirlos a nombre para poder comparar contra los de USA. */
  function nombres(ids, mapa) {
    return ids.map(function (id) { return mapa[id]; }).filter(Boolean);
  }

  function coleccionActual() {
    var m = location.pathname.match(/\/collections\/([^/?]+)/);
    return m ? m[1] : null;
  }

  function filtrar() {
    var p = new URLSearchParams(location.search);
    var col = coleccionActual();

    /* En SALE no va ninguna tarjeta de USA. Esa coleccion es automatica por
       "precio rebajado" y el JSON del catalogo solo trae precio, sin precio
       tachado: las tarjetas entraban a precio lleno, mezcladas entre los
       rebajados, y el cliente las leia como oferta. Son 30 productos que
       arrastran "hot-sale" entre sus colecciones heredado de la tienda de
       USA. (2026-10-24) */
    if (col === "hot-sale") return [];
    var talles = valores(p, "filter.v.option.talla del calzado");
    var marcas = nombres(valores(p, "filter.p.m.custom.marca"), datos.marcas);
    var atletas = nombres(valores(p, "filter.p.m.custom.atletas"), datos.atletas);
    var soloStock = valores(p, "filter.v.availability").indexOf("1") > -1;

    return datos.productos.filter(function (x) {
      if (col && col !== "all" && (x.c || []).indexOf(col) === -1) return false;
      if (soloStock && !x.s) return false;
      if (marcas.length && marcas.indexOf(x.m) === -1) return false;
      if (atletas.length && atletas.indexOf(x.a) === -1) return false;
      if (talles.length && !talles.some(function (t) {
        return (x.z || []).indexOf(t) > -1;
      })) return false;
      return true;
    });
  }

  function tarjeta(x) {
    var li = document.createElement("li");
    li.className = "grid__item catalogo-usa__item" + (x.s ? "" : " catalogo-usa__item--agotado");
    li.setAttribute("data-catalogo-usa-item", "");
    var img = x.i.indexOf("?") > -1 ? x.i + "&width=533" : x.i + "?width=533";
    var precio = x.s
      ? pesos(x.p)
      : '<span class="catalogo-usa__agotado">Agotado</span>';
    li.innerHTML =
      '<div class="card-wrapper product-card-wrapper underline-links-hover">' +
      '<div class="card card--standard card--media" style="--ratio-percent:100.0%;">' +
      '<div class="card__inner color-scheme-2 gradient ratio" style="--ratio-percent:100.0%;">' +
      '<span class="label-stock-usa">Stock 🇺🇸</span>' +
      '<div class="card__media"><div class="media media--transparent">' +
      '<img src="' + img + '" alt="" loading="lazy" width="533" height="533">' +
      '</div></div></div>' +
      '<div class="card__content"><div class="card__information">' +
      '<h3 class="card__heading h5"><a class="full-unstyled-link" href="' +
      datos.destino + x.h + '" rel="noopener">' + x.t + '</a></h3>' +
      '<p class="producto-categoria">Calzado de básquet</p>' +
      '<div class="card-information"><div class="price"><div class="price__container">' +
      '<div class="price__regular"><span class="price-item price-item--regular">' +
      precio + '</span></div></div></div></div>' +
      '</div></div></div></div>';
    return li;
  }

  /* DONDE VA CADA TARJETA.

     Hasta el 2026-10-26 se repartían parejo, sin mirar el precio. Con la
     grilla ordenada por "menor precio" quedaba una de $343.990 entre dos de
     $119.990 y el orden se leía como roto. Ahora, si el orden es por precio,
     cada tarjeta se mete donde le corresponde comparando contra el precio que
     muestran las tarjetas nativas; en los demás órdenes (más vendidos, más
     nuevos, manual) no hay con qué comparar, así que se reparten parejo. */
  function ordenActual() {
    return new URLSearchParams(location.search).get("sort_by") || "";
  }

  /* El precio que se VE en una tarjeta nativa. Si está rebajada, el que vale
     es el de oferta, que es contra el que ordena Shopify. */
  function precioVisible(li) {
    var el = li.querySelector(".price-item--sale") ||
             li.querySelector(".price-item--regular") ||
             li.querySelector(".price-item");
    if (!el) return null;
    var txt = String(el.textContent).replace(/[^\d.,]/g, "");
    if (!txt) return null;
    /* Formato es-AR: punto de miles, coma decimal. */
    var n = parseFloat(txt.replace(/\./g, "").replace(",", "."));
    return isNaN(n) ? null : n;
  }

  function nativas(grid) {
    return grid.querySelectorAll(".grid__item:not([data-catalogo-usa-item])");
  }

  function colocar(grid, lista) {
    var orden = ordenActual();
    var asc = orden === "price-ascending";
    var desc = orden === "price-descending";

    if (!asc && !desc) {
      var ns = nativas(grid);
      var cuantas = ns.length;
      lista.forEach(function (x, i) {
        var li = tarjeta(x);
        var pos = cuantas ? Math.round((i + 1) * cuantas / (lista.length + 1)) : 0;
        if (cuantas && pos < cuantas) grid.insertBefore(li, ns[pos]);
        else grid.appendChild(li);
      });
      return;
    }

    /* Ordenadas entre sí primero: así dos tarjetas de USA que caen en el mismo
       hueco quedan en el orden correcto una respecto de la otra. */
    lista = lista.slice().sort(function (a, b) {
      return asc ? Number(a.p) - Number(b.p) : Number(b.p) - Number(a.p);
    });

    lista.forEach(function (x) {
      var li = tarjeta(x);
      var mio = Number(x.p);
      var ns = nativas(grid);
      var destino = null;
      for (var i = 0; i < ns.length; i++) {
        var suyo = precioVisible(ns[i]);
        if (suyo === null) continue;
        if (asc ? suyo > mio : suyo < mio) { destino = ns[i]; break; }
      }
      if (destino) grid.insertBefore(li, destino);
      else grid.appendChild(li);
    });
  }

  /* RED DE SEGURIDAD DE LAS ANIMACIONES.

     Las tarjetas nacen en opacity 0.01 (.scroll-trigger.animate--slide-in) y
     se revelan cuando un IntersectionObserver les saca la clase
     scroll-trigger--offscreen. Ese observador lo arma animations.js UNA sola
     vez, al cargar la pagina. Cuando la grilla se vuelve a dibujar por AJAX
     --filtros, scroll infinito-- hay tarjetas que quedan con la clase puesta
     y sin nadie que se la saque: se ven en blanco. Reportado por el usuario
     el 2026-10-30 filtrando por disponibilidad, y no era la primera vez.

     Esto no arregla la causa, la tapa: si una tarjeta sigue marcada como
     fuera de pantalla pero en realidad esta a la vista, se le saca la clase a
     mano. Vale tanto para las nativas como para cualquier otra. */
  function rescatarOcultas() {
    var ocultas = document.querySelectorAll(
      "#product-grid .scroll-trigger.scroll-trigger--offscreen"
    );
    if (!ocultas.length) return;
    var alto = window.innerHeight || document.documentElement.clientHeight;
    ocultas.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < alto && r.bottom > 0) {
        el.classList.remove("scroll-trigger--offscreen");
      }
    });
  }

  var rescateProgramado = null;
  function programarRescate() {
    clearTimeout(rescateProgramado);
    rescateProgramado = setTimeout(rescatarOcultas, 150);
  }

  window.addEventListener("scroll", programarRescate, { passive: true });
  window.addEventListener("resize", programarRescate, { passive: true });

  function pintar() {
    var grid = document.getElementById("product-grid");
    if (!grid || !datos) return;

    /* Desconectar antes de tocar el DOM: si no, estos cambios despiertan al
       observador que llamó a pintar() y el repintado no se detiene nunca. */
    if (observador) observador.disconnect();

    grid.querySelectorAll(
      "[data-catalogo-usa-item], [data-catalogo-usa-mas]"
    ).forEach(function (n) { n.remove(); });

    var todas = filtrar();
    var lista = todas.slice(0, cuantasEntran(grid, todas.length));

    if (lista.length) {
      colocar(grid, lista);
    }

    if (observador) conectar();
    programarRescate();
  }

  /* El scroll infinito y los filtros de Dawn vuelven a dibujar la grilla por
     AJAX; cuando eso pasa hay que repintar para repartirlas de nuevo. */
  function conectar() {
    var cont = document.getElementById("ProductGridContainer") ||
               document.getElementById("product-grid");
    if (!cont) return;
    observador.observe(cont.parentNode || cont, { childList: true, subtree: true });
  }

  function observar() {
    var cont = document.getElementById("ProductGridContainer") ||
               document.getElementById("product-grid");
    if (!cont) return;
    observador = new MutationObserver(function () {
      clearTimeout(observar._t);
      observar._t = setTimeout(pintar, 80);
    });
    conectar();
  }

  fetch(FUENTE)
    .then(function (r) { return r.json(); })
    .then(function (d) { datos = d; observar(); pintar(); })
    .catch(function () {});

  window.addEventListener("popstate", function () { setTimeout(pintar, 80); });
})();

